

export const AddBots = () => {




  return (
    <div className='w-full flex flex-col justify-center items-center pb-[20px] bg-hoory-100  rounded-lg  '>
      <div className="w-full h-[60px] flex items-center px-10">
        <h1 className="font-bold text-xl">Add Bots</h1>
      </div>
      <div className="w-full flex flex-wrap border-t border-hoory-75 p-4">
        <form className="md:w-6/12 w-full md:pr-4 pr-0">
          <div className="w-full flex flex-col">
            <span className="text-sm mb-2  ml-2 font-bold ">Bot Name</span>
            <input type="text" placeholder="Enter your bot name " className="w-full h-[40px] rounded-md border border-hoory-75 bg-transparent px-[10px] transition-all duration-500 focus:outline-none focus:border-pos-100 text-sm" />
          </div>
          <div className="w-full flex flex-col mt-6">
            <span className="text-sm mb-2  ml-2 font-bold ">Description</span>
            <textarea placeholder="Enter your Description " className="w-full h-[100px] rounded-md border border-hoory-75 bg-transparent p-[10px] transition-all duration-500 focus:outline-none focus:border-pos-100 text-sm" />
          </div>
          <button className="w-full h-[40px] bg-hoory-200 text-white text-sm mt-10 rounded-md">Submit</button>
        </form>
        <div className="md:w-6/12 w-full md:pl-4 pl-0 md:mt-0 mt-10">
          <div className="w-full bg-hoory-175 rounded-md p-3 flex flex-col">
            <span className="font-bold text-sm">You can add your domain here or you can add it in your domain panel </span>
            <span className="my-2 font-bold text-[17px]">DNS Record:</span>
            <span className="text-xs mt-2">1.ns1.test.com</span>
            <span className="text-xs mt-2">2.ns1.test.com</span>
            <span className="text-xs mt-2">3.ns1.test.com</span>
            <span className="text-xs mt-2">4.ns1.test.com</span>

          </div>
        </div>
      </div>
    </div >
  )
}